import { render } from "./TagsEditor.vue?vue&type=template&id=f0703d20&scoped=true"
import script from "./TagsEditor.vue?vue&type=script&lang=js"
export * from "./TagsEditor.vue?vue&type=script&lang=js"

import "./TagsEditor.vue?vue&type=style&index=0&id=f0703d20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0703d20"]])

export default __exports__